import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RouterLink } from '@angular/router';

/**
 * interfaces
 */
import { IAdvertisementResponse } from 'src/app/core/interfaces/ads/advertisement';

/**
 * shared components
 */
import { AdvertisementCardComponent } from 'src/app/shared.standalone/advertisement-card/advertisement-card.component';

@Component({
  standalone: true,
  selector: 'app-info-card-model',
  templateUrl: './info-card-model.component.html',
  styleUrls: ['./info-card-model.component.scss'],
  imports: [
    RouterLink,
    /**
     * shared components
     */
    AdvertisementCardComponent
  ]
})
export class InfoCardModelComponent implements OnInit {

  // init Inputs
  @Input({ alias: 'submitView' }) SubmitView: boolean | null = null
  @Input({ alias: 'data', required: true }) data: IAdvertisementResponse = null

  // init OutPut
  @Output() CloseModel =  new EventEmitter<null>()

  constructor() { }

  ngOnInit(): void {
  }

  /**
   * 
   */
  public Close(): void {
    
    this.CloseModel.emit(null)
    
    this.data = null

  }

}
